const STANDARD_TYPE_KEY = 'standartType';

export function prepareOnboardingStandard(storage: Storage = localStorage): void {
  storage.removeItem(STANDARD_TYPE_KEY);
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/header/employee-onboarding/onboarding-standard-navigation.ts